import React from 'react';
import './ProductReviewsModal.scss';

const reviews = [
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 5 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 4 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 5 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 3 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 4 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 5 },
  { name: 'Customer name', text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', rate: 4 },
];

function StarRating({ rate }) {
  return (
    <span className="stars">
      {[1,2,3,4,5].map(i => (
        <span key={i} className={i <= rate ? 'star filled' : 'star'}>★</span>
      ))}
    </span>
  );
}

export default function ProductReviewsModal({ onClose }) {
  return (
    <div className="reviews-modal-backdrop">
      <div className="reviews-modal">
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="modal-header">
          <div className="modal-title">Programming book for professionals</div>
          <div className="overall-rate">
            <span>Overall rate</span>
            <StarRating rate={4} />
          </div>
        </div>
        <div className="reviews-list">
          {reviews.map((r, idx) => (
            <div className="review-row" key={idx}>
              <div className="review-info">
                <div className="review-name">{r.name}</div>
                <div className="review-text">{r.text}</div>
              </div>
              <StarRating rate={r.rate} />
            </div>
          ))}
        </div>
            <div className="form-buttons">
          <button type="submit" className="publish">PUBLISH</button>
          <button type="button" className="cancel">CANCEL</button>
        </div>
      </div>
    </div>
  );
} 